module.exports = __webpack_public_path__ + "img/male-elderly-hand.9ef43f60.svg";